/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrderDetailsExtendedService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { OrderDetailsExtendedData, OrderDetailsExtendedService } from './OrderDetailsExtended.service';
import { OrderDetailsExtendedSearchComponent }  from './OrderDetailsExtendedSearch.component';

@Component({
	selector: 'my-OrderDetailsExtended',
	template: require('./OrderDetailsExtendedList.component.html'),
	providers: [OrderDetailsExtendedService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrderDetailsExtendedListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	OrderDetailsExtendedList: OrderDetailsExtendedData[];
	newOrderDetailsExtended: OrderDetailsExtendedData;
	selectedOrderDetailsExtended: OrderDetailsExtendedData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(OrderDetailsExtendedSearchComponent) filterComponent: OrderDetailsExtendedSearchComponent;

	sortExpression: string = "OrderID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private OrderDetailsExtendedService: OrderDetailsExtendedService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newOrderDetailsExtended = new OrderDetailsExtendedData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.OrderDetailsExtendedService.getAll().subscribe(record => this.OrderDetailsExtendedList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getOrderDetailsExtendedByPaging();

		/*
		this.OrderDetailsExtendedList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getOrderDetailsExtended() {
		this.OrderDetailsExtendedService.getAll()
			.subscribe(data => this.OrderDetailsExtendedList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on OrderDetailsExtendedSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getOrderDetailsExtendedByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getOrderDetailsExtendedByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getOrderDetailsExtendedByPaging();
	}
	
	// Get records by paging
	getOrderDetailsExtendedByPaging() {
		this.OrderDetailsExtendedService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.OrderDetailsExtendedList=data.OrderDetailsExtendedList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addOrderDetailsExtended() {
		this.OrderDetailsExtendedService.addOrderDetailsExtendedData(this.newOrderDetailsExtended).subscribe(record => console.log(record));
		this.getOrderDetailsExtended();
	}
  
	// Updates existing record
	updateOrderDetailsExtended() {
		this.OrderDetailsExtendedService.updateOrderDetailsExtendedData(this.selectedOrderDetailsExtended).subscribe(record => console.log(record));
		this.getOrderDetailsExtended();
	}

	// Deletes record with specified id
	deleteOrderDetailsExtended(id: string) {
		if (window.confirm('Are you sure you want to delete this OrderDetailsExtended?') == true)
		{
			this.OrderDetailsExtendedService.deleteOrderDetailsExtended(id)
			.subscribe(data => this.getOrderDetailsExtended(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getOrderDetailsExtendedByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getOrderDetailsExtendedByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getOrderDetailsExtendedByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getOrderDetailsExtendedByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: OrderDetailsExtendedData) {
		this.router.navigate(['/OrderDetailsExtended', item.OrderID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: OrderDetailsExtendedData) {
		this.router.navigate(['/OrderDetailsExtended/Details', item.OrderID]);
	}

	// Set record as selected
	SelectOrderDetailsExtended(item: OrderDetailsExtendedData) {
		this.selectedOrderDetailsExtended = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: OrderDetailsExtendedData) {
		return item.OrderID === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetailsExtended/OrderDetailsExtendedList.component.ts